import type { FieldMatcher } from '@cdw-ae/filter-bar-interfaces';

export const IsNotMatcher: FieldMatcher = {
  name: 'isNot',
  displayName: 'is not',
  hasEditor: true,
  options: {
    setValue: (value): string => String(value),
    chipFormatter: (value: string): string =>
      `: ${String(value).charAt(0).toUpperCase() + String(value).slice(1)}`,
  },
  editorOptions: {
    selectionOptions: [],
  },
};
